<script>
import moment from 'moment'

export default {
  name: 'rex-rounded-time',
  props: {
    label: {
      type: String,
      default: () => null
    },
    storeModule: {
      type: String,
      default: () => '',
      required: true
    },
    getterName: {
      type: String,
      default: () => null,
      required: true
    },
    setterName: {
      type: String,
      default: () => null,
      required: true
    },
    target: {
      type: String,
      default: () => null,
      required: true
    },
    cssClass: {
      type: String,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    showLabel: {
      type: Boolean,
      default: () => true
    }
  },
  computed: {
    value: {
      get() {
        let data = this.$store.getters[`${this.storeModule}/${this.getterName}`](this.target)

        if (moment.unix(data).isValid()) {
          data = moment.unix(data).toDate()
        } else {
          data = moment(data, 'HH:mm').toDate()
        }

        return data
      },
      set(value) {
        const formattedTime = moment(value).format('HH:mm')

        this.$store.commit(`${this.storeModule}/${this.setterName}`, {
          target: this.target,
          value: formattedTime,
        })

        this.$emit('onChange', {
          event: formattedTime,
          element: this.$vnode.elm
        })
      }
    }
  },
}
</script>

<template>
  <div
    :class="cssClass"
    class="rex-rounded-field"
  >
    <h3
      v-if="showLabel"
      class="rex-rounded-field--label"
    >
      {{ label }}
    </h3>
    <b-timepicker
      v-model="value"
      class="rex-rounded-time"
      type="is-primary"
      :disabled="disabled"
    />
  </div>
</template>
